// API Service file (api.service.ts)
import { signInWithEmailAndPassword, UserCredential,  User, getIdToken } from 'firebase/auth';
import { addDoc, collection, doc, getDocs, query, serverTimestamp, setDoc, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../firebase/auth.firebase';
import { ProfileModel } from '../model/profile.model';
import axios from "axios";
import config from '../config';

export async function loginWithEmail(email: string, password: string): Promise<UserCredential> {
    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        return userCredential;
    } catch (error: any) {
        throw new Error(error.message);
    }
}
export async function getUsers(): Promise<ProfileModel[]> {
    try {
        const usersRef = collection(db, 'users');
        const snapshot = await getDocs(usersRef);

        const users: ProfileModel[] = snapshot.docs.filter((item) => item.data().email != "gsb.aida.noreply@gmail.com").map(doc => {
            const data = doc.data();
            return {
                uuid: doc.id,
                email: data.email,
                created_at: data.created_at.toDate(),
                last_login: data.last_login ? data.last_login.toDate() : null,
                role: data.role,
                status: data.status
            };
        });

        return users;
    } catch (error: any) {
        console.error('Error fetching users:', error.message);
        throw new Error(error.message);
    }
}
export async function deleteUser(uid, token): Promise<void> {
    try {

        return axios.post(config.cloud_function.base_url + "deleteUser", {
            uid: uid
        }, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
        ).then(res => res.data).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(error.message);
    }
}
export async function updateUserRole(uid: string, role:string): Promise<void> {
    try {
        // Reference to the user's document in the Firestore "users" collection
        const userDocRef = doc(db, 'users', uid);
        // Update the status field
        const result = await updateDoc(userDocRef, {
            role: role, // Set the new status
        });

        return result;
    } catch (error: any) {
        console.error(`Error updating user status for UID: ${uid}`, error.message);
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function updateUserLastLogin(uid: string): Promise<void> {
    try {
        // Reference to the user's document in the Firestore "users" collection
        const userDocRef = doc(db, 'users', uid);
        // Update the status field
        const result = await updateDoc(userDocRef, {
            last_login: serverTimestamp(), // Set the new status
        });

        return result;
    } catch (error: any) {
        console.error(`Error updating user status for UID: ${uid}`, error.message);
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function updateUserStatus(uid: string, status: string): Promise<void> {
    try {
        // Reference to the user's document in the Firestore "users" collection
        const userDocRef = doc(db, 'users', uid);
        // Update the status field
        const result = await updateDoc(userDocRef, {
            status: status, // Set the new status
        });

        return result;
    } catch (error: any) {
        console.error(`Error updating user status for UID: ${uid}`, error.message);
        throw new Error(`Failed to update user status: ${error.message}`);
    }
}
export async function createUser(
    email: string,
    role: string,
    token: string
): Promise<void> {
    try {
        // Validate email and password
        if (!email || !email.includes('@')) {
            throw new Error('Invalid email format.');
        }

        if (!token) {
            throw new Error('Missing Token');
        }

        // Save admin session's ID token
        const adminUser = auth.currentUser;
        if (!adminUser) {
            throw new Error('Admin user is not authenticated.');
        }
        // Check role limits
        const roleLimit = role === 'Admin' ? 20 : role === 'Staff' ? 5 : Infinity; // Define role limits
        const usersRef = collection(db, 'users');
        const roleQuery = query(usersRef, where('role', '==', role));
        const roleSnapshot = await getDocs(roleQuery);

        if (roleSnapshot.size >= roleLimit) {
            throw new Error(
                `Cannot create a new user. The maximum limit for role '${role}' is ${roleLimit}.`
            );
        }



        // Return the created user's details
        return axios.post(config.cloud_function.base_url + "addNewStaff", {
            email: email,
            role: role
        }, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
        ).then(res => res.data).catch(err => Promise.reject(err))
    } catch (error: any) {
        console.error('Error creating user:', error.message);
        throw new Error(error.message);
    }
}
export async function sendInvite(email, token): Promise<void> {
    try {
        return axios.post(config.cloud_function.base_url + "addNewStaff", {
            email: email,
            role: "staff"
        }, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
        ).then(res => res.data).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export async function getUserCount(): Promise<void> {
    try {
        return axios.get(config.cloud_function.base_url + "getUserCount", {
            headers: {
                'content-type': 'application/json'
            }
        }
        ).then(res => res.data).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(error.message);
    }
}
export async function resetpassword(email: string): Promise<void> {
    try {
        return axios.post(config.cloud_function.base_url + "resetpassword", {email : email},{
            headers: {
                'content-type': 'application/json'
            }
        }
        ).then(res => res.data).catch(err => Promise.reject(err))
    } catch (error: any) {
        return (error.message);
    }
}
export async function inviteUser(email: string): Promise<void> {
    try {
        return axios.post(config.cloud_function.base_url + "invite-email", { email: email }, {
            headers: {
                'content-type': 'application/json'
            }
        }
        ).then(res => res.data).catch(err => Promise.reject(err))
    } catch (error: any) {
        throw new Error(error.message);
    }
}

const apiService = axios.create({
    baseURL: config.ai.base_url,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiService.interceptors.request.use(async (config) => {
    const currentUser = auth.currentUser;

    if (currentUser) {
        const idToken = await getIdToken(currentUser, true);
        config.headers['Authorization'] = `Bearer ${idToken}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

export default apiService;
